<template>
  <div>
    <!--<div class="flex flex-between mb8">
      <div class="header-time-box" v-if="$store.state.role === 'school-role'">
        申报时间：{{ startTime }}—{{ endTime }}
      </div>
      <div class="" v-else></div>
    </div>-->
    <div class="header-search-box flex align-items-center border-box">
      <div class="flex align-items-center" style="margin-right: 8px">
        <div v-if="this.$route.name === 'szStudio'" style="width: 80px">
          工作室名称 :
        </div>
        <div
          v-if="this.$route.name === 'educationalBrand'"
          style="width: 145px"
        >
          特色文化育人品牌名称:
        </div>
        <div v-if="this.$route.name === 'szMicroClass'" style="width: 90px">
          思政微课名称:
        </div>
        <!--class="input-style"-->
        <a-input
          style="width: 110px"
          type="text"
          v-model="queryCriteria.name"
          allowClear
          placeholder=""
        />
      </div>
      <div class="flex align-items-center">
        <div>申报年份：</div>
        <a-date-picker
          style="margin-right: 8px; width: 130px"
          v-model="queryCriteria.applyYear"
          :open="yearShowOne"
          :locale="locale"
          :format="'YYYY'"
          mode="year"
          @openChange="openChangeOne"
          @panelChange="panelChangeOne"
        />
      </div>
      <div class="flex align-items-center">
        <div>审核状态：</div>
        <a-select
          default-value="全部"
          style="width: 110px"
          @change="handleChange"
        >
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option value="0"> 保存 </a-select-option>
          <a-select-option value="1"> 待审核 </a-select-option>
          <a-select-option value="2"> 审核通过 </a-select-option>
          <a-select-option value="3"> 审核失败 </a-select-option>
        </a-select>
      </div>
      <div
        class="search-btn flex flex-center align-items-center"
        @click="goQuery"
      >
        <img class="img-box" src="../../assets/images/img48.png" alt="" />
        <div>查询</div>
      </div>
      <!-- <a-dropdown v-if="btnShow == true" >
       <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1"> 新增</a-menu-item>
          <a-menu-item key="2"> 导入新增 </a-menu-item>
        </a-menu> 
        <a-button style="margin-left: 8px"> 新增 <a-icon type="down" /> </a-button>
    </a-dropdown> -->
      <!-- <div class="add-btn" style="margin-left:6px;" v-if="btnShow == true" @click="jumpPages(type)">
        新增
      </div> -->
      <div
        class="add-btn"
        style="margin-left: 6px"
        v-if="btnShow == true"
        @click="jumpPage(type)"
      >
        新增
      </div>
      <div
        class="add-btn"
        style="margin-left: 6px"
        v-if="btnShow == true && $store.state.role == 'school-role'"
        @click="batchsubmis"
      >
        批量提交
      </div>
      <!-- <div class="add-btn" style="margin-left:6px;" v-if="btnShow == true" @click="importsj(type)">
        导入
      </div> -->
      <!-- <div class="add-btn" style="margin-left:6px;" v-if="btnShow == true" @click="tjsl(type)">
                      统计数量
      </div> -->
    </div>
    <div>
      <a-table
        style="text-align: center"
        :row-selection="rowSelection"
        :locale="{ emptyText: '暂无数据' }"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="true"
        rowKey="id"
        :scroll="{ x: 1280 }"
      >
        <span slot="operate"
          >操作<a-tooltip>
            <template slot="title">
              1.编辑按钮：<br />
              对数据进行编辑。(在【已保存】或【审核驳回】状态下可进行编辑)<br />
              2.移除按钮：<br />
              对数据进行移除(移除数据不可找回)。(在【已保存】或【审核驳回】状态下可进行移除)<br />
              3.更新按钮：<br />
              可以对数据进行新增,编辑和移除，完成以上任一操作，数据自动进入【待审核】状态。<br />
              4.更新详情按钮：<br />
              可查看所有变更记录，当状态为【审核驳回】时,可在当前页面编辑并重新发起审核<br />
              5.预览按钮：<br />
              对当前数据进行预览，预览状态下不可进行任何操作
            </template>
            <a-icon
              type="question-circle"
              style="margin-left: 5px; cursor: pointer"
            />
          </a-tooltip>
        </span>
        <span slot="customTitle"
          >工作室名称<a-tooltip>
            <template slot="title"> 审核通过后,数据分析中可统计 </template>
            <a-icon
              type="question-circle"
              style="margin-left: 5px; cursor: pointer"
            />
          </a-tooltip>
        </span>
        <span slot="shzt"
          >审核状态<a-tooltip>
            <template slot="title">
              1.新增或编辑完成后,点击保存按钮状态改为【已保存】：<br />
              2.点击批量提交按钮后状态从【已保存】改为【待审核】,此时数据将无法修改<br />
              3.当审核员审核完成后,状态改为【审核通过】或【审核驳回】：<br />
              4. 鼠标点击【审核驳回】状态文字上可查看审核驳回原因<br />
              5.【审核驳回】状态下全部内容可进行修改,点击提交后,再次进入【待审核】状态
            </template>
            <a-icon
              type="question-circle"
              style="margin-left: 5px; cursor: pointer"
            />
          </a-tooltip>
        </span>

        <span slot="customTitle1"
          >品牌名称<a-tooltip>
            <template slot="title"> 审核通过后,数据分析中可统计 </template>
            <a-icon
              type="question-circle"
              style="margin-left: 5px; cursor: pointer"
            />
          </a-tooltip>
        </span>
        <span slot="customTitle2"
          >思政微课名称<a-tooltip>
            <template slot="title"> 审核通过后,数据分析中可统计 </template>
            <a-icon
              type="question-circle"
              style="margin-left: 5px; cursor: pointer"
            />
          </a-tooltip>
        </span>
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 30px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer; margin-right: 10px"
            @click="editInfo(record)"
            v-if="
              btnShow == true &&
              (record.auditState == '0' || record.auditState == '3')
            "
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>

          <!-- && $route.name!='szMicroClass' -->
          <div
            class="flex align-items-center"
            style="cursor: pointer; margin-right: 10px"
            v-if="
              btnShow == true &&
              record.auditState != '0' &&
              record.auditState != '1' &&
              record.auditState != '3'
            "
            @click="preview(record, 'edit')"
          >
            <img
              class="img-box-preview"
              src="../../assets/images/img100.png"
              alt=""
            />
            <span>更新</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer; margin-right: 10px"
            v-if="btnShow == true && record.auditState == 2"
            @click="goAudit(record, 'edit')"
          >
            <img
              class="img-box-preview"
              src="../../assets/images/img101.png"
              alt=""
            />
            <span>更新详情</span>
          </div>
          <!-- && (record.auditState=='0' || record.auditState=='3') -->
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
            v-if="
              btnShow == true &&
              record.auditState != '2' &&
              record.auditState != '1'
            "
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer; margin-right: 10px"
            v-if="btnShow == true"
            @click="preview(record, 'preview')"
          >
            <img
              class="img-box-preview"
              src="../../assets/images/img51.png"
              alt=""
            />
            <span>预览</span>
          </div>
        </span>
        <template slot="tdcy" slot-scope="text, record">
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="teacherlist(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
          <div
            @click="teacherlist(record)"
            style="color: #e5914b; cursor: pointer"
          >
            {{ text }}
          </div>
        </template>
        <template slot="xtdcy" slot-scope="text, record">
          <div
            @click="xteacherlist(record)"
            style="color: #e5914b; cursor: pointer"
          >
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="xteacherlist(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="auditState" slot-scope="text, record">
          <div v-if="text == '0'">已保存</div>
          <div v-if="text == '1'" style="color: #1890ff">待审核</div>
          <div v-if="text == '2'" style="color: rgb(46 190 73)">审核通过</div>
          <div v-if="text == '3'" style="color: #e1301e; cursor: pointer">
            <a-tooltip>
              <template slot="title">
                {{ record.auditDesc }}
              </template>
              审核驳回
            </a-tooltip>
          </div>
        </template>
        <template slot="zjyl" slot-scope="text, record">
          <div
            class="flex align-items-center"
            style="cursor: pointer; justify-content: center"
            @click="zjlist(record)"
          >
            <img
              class="img-box-preview"
              src="../../assets/images/img51.png"
              alt=""
            />
            <span>预览</span>
          </div>
        </template>
        <template slot="ppjd" slot-scope="text, record">
          <div @click="ppjd(record)" style="color: #e5914b; cursor: pointer">
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="ppjd(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="pphd" slot-scope="text, record">
          <div @click="pphd(record)" style="color: #e5914b; cursor: pointer">
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="pphd(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="cgyl" slot-scope="text, record">
          <div @click="cglist(record)" style="color: #e5914b; cursor: pointer">
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="cglist(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="brandArea" slot-scope="text, record">
          <div
            @click="arealist(record)"
            style="color: #e5914b; cursor: pointer"
          >
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="arealist(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="sbs" slot-scope="text, record, index">
          <div v-if="record.hasDeclaration == '0'">未上传</div>
          <div
            v-else
            @click="sbs(record)"
            style="color: #e5914b; cursor: pointer"
          >
            已上传
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="sbs(record)"
	            v-else
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="sp" slot-scope="text, record">
          <div v-if="record.hasResource == '0'">未上传</div>
          <div
            v-else
            @click="sp(record)"
            style="color: #e5914b; cursor: pointer"
          >
            已上传
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;padding:0px 30px;"
	            @click="sp(record)"
	            v-else
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
          <!--<template slot="applyFilesFull" slot-scope="text">
          <img
            v-if="text == 0"
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt=""
            title="资料完整"
          />
          <img
            v-else
            class="img-box-hint"
            src="../../assets/images/img58.png"
            alt=""
            title="资料不完整"
          />-->
        </template>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>移除该信息将同步移除关联的申报文件,视频,您确定要移除吗?</p>
    </a-modal>
    <div class="preview-pop-box" v-if="showPreviewPop">
      <div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
        <preview
          :preViewData="preViewData"
          type="school"
          @goNewPage="goNewPage"
          @closePreview="showPreviewPop = false"
        >
        </preview>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <tablesmic
          :title="title"
          :num="num"
          :record="record"
          @closePreview="showtable = false"
        >
        </tablesmic>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showiframe">
      <div class="preview-boxs" style="height: 90%">
        <newpreview
          :previewUrl="previewUrl"
          @closePreview="showiframe = false"
        ></newpreview>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showvideo">
      <div class="preview-boxs" style="height: 600px">
        <!-- :previewUrl="previewUrl" -->
        <videopreview
          :sj="sjData"
          @closePreview="showvideo = false"
        ></videopreview>
      </div>
    </div>
    <a-modal
      :title="titles"
      width="40%"
      :visible="importshow"
      :maskClosable="false"
      :keyboard="false"
      @cancel="handleCancel"
      @ok="handleOks"
      ok-text="确认"
      cancel-text="取消"
    >
      <div>
        <a-form-model
          :model="form"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
        >
          <a-form-model-item label="导入类型" style="margin-bottom: 0px">
            <a-radio-group v-model="form.chatType">
              <a-radio value="1">基本信息导入</a-radio>
              <a-radio value="2">全量导入</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div @click="downmb" v-if="form.chatType == 1" class="downmb">
            下载基本信息导入模板
          </div>
          <div @click="downmb" v-else class="downmb">下载全量信息导入模板</div>
          <div>
            <a-upload
              :before-upload="beforeUpload"
              :custom-request="noopUpload"
              accept=".xls,.xlsx"
              :showUploadList="false"
              :disabled="loadings"
            >
              <a-button
                style="margin-right: 20px"
                :loading="loadings"
                :disabled="loadings"
                type="primary"
                >导入</a-button
              >
            </a-upload>
            <a
              :href="path + item.fileUrl"
              v-for="(item, index) in list"
              :key="index"
              v-if="list.length > 0"
              >{{ item.fileName }}</a
            >
          </div>
        </a-form-model>
      </div>
    </a-modal>
    <a-modal
      title="统计数量"
      width="40%"
      :visible="tjshow"
      :maskClosable="false"
      :keyboard="false"
      @cancel="tjCancel"
      @ok="tjOks"
      ok-text="确认"
      cancel-text="取消"
    >
      <div class="flex align-items-center" style="margin-right: 8px">
        <div v-if="this.$route.name === 'szStudio'" style="width: 80px">
          工作室数量 :
        </div>
        <div
          v-if="this.$route.name === 'educationalBrand'"
          style="width: 145px"
        >
          特色文化育人品牌数量:
        </div>
        <div v-if="this.$route.name === 'szMicroClass'" style="width: 90px">
          思政微课数量:
        </div>
        <a-input
          style="width: 180px"
          type="text"
          v-model="query.name"
          allowClear
          placeholder=""
        />
      </div>
    </a-modal>
    <identitypdf ref="identitypdf" @importsuccess="handleOks"></identitypdf>
  </div>
</template>

<script>
import tablesmic from "./tableszMic";
import preview from "./preview";
import newpreview from "./newpreview";
import videopreview from "./videopreview";
import identitypdf from "./identityPdf";
import { schoolMaxNum } from "../../api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { baseURL } from "@/utils/request.js";
import {
  getAction,
  postAction,
  putAction,
  deleteAction,
  lxApplyexportTemplate,
  lxApplyexportQlTemplate,
} from "@/api/index";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    dataIndex: "name",
    key: "name",
    slots: { title: "customTitle" },
    id: "name",
    align: "center",
    width: 150,
  },
  {
    title: "工作室地点",
    dataIndex: "address",
    id: "address",
    align: "center",
    width: 150,
  },
  {
    // title: "审核状态",
    slots: { title: "shzt" },
    dataIndex: "auditState",
    id: "auditState",
    align: "center",
    scopedSlots: { customRender: "auditState" },
    width: 150,
  },
  {
    title: "工作室建设日期",
    dataIndex: "foundTime",
    id: "foundTime",
    align: "center",
    width: 150,
  },
  {
    title: "申报年份",
    dataIndex: "applyYear",
    id: "applyYear",
    align: "center",
    width: 100,
  },
  {
    title: "工作室团队成员",
    dataIndex: "groupNum",
    id: "groupNum",
    align: "center",
    scopedSlots: { customRender: "xtdcy" },
    width: 150,
  },
  // {
  //     title: "资金",
  //     dataIndex: "brandMode",
  //     id: "brandMode",
  //     align: "center",
  //     scopedSlots: { customRender: "zjyl" },
  //     width: 100,
  // },
  {
    title: "成果",
    dataIndex: "achievementNum",
    id: "achievementNum",
    align: "center",
    scopedSlots: { customRender: "cgyl" },
    width: 100,
  },
  {
    title: "思政实践基地",
    dataIndex: "szBaseNum",
    id: "szBaseNum",
    align: "center",
    scopedSlots: { customRender: "brandArea" },
    width: 140,
  },
  {
    title: "申报书",
    dataIndex: "declarationName",
    id: "declarationName",
    align: "center",
    scopedSlots: { customRender: "sbs" },
    width: 100,
  },
  {
    // title: "操作",
    slots: { title: "operate" },
    fixed: "right",
    id: "action",
    align: "center",
    width: 340,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "",
  components: { preview, tablesmic, newpreview, videopreview, identitypdf },
  props: {
    columns: {
      type: Array,
      default: () => columns,
    },
    loading: Boolean,
    dataList: {
      type: Array,
      default: () => [],
    },
    titleType: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    startTime: {
      type: String,
      default: "",
    },
    endTime: {
      type: String,
      default: "",
    },
    pagination: {
      type: Object,
    },
    btnShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      list: [],
      confirmLoading: false,
      importshow: false,
      showtable: false,
      title: "",
      titles: "",
      num: 0,
      path: baseURL,
      record: {},
      showDeleteModel: false,
      deteleId: null,
      showPreviewPop: false,
      fullscreen: false,
      preViewData: null,
      queryCriteria: {
        name: "",
        applyYear: "",
        auditState: "",
      },
      query: {
        name: "",
      },
      form: {
        chatType: "1",
      },
      data: [],
      previewUrl: "",
      showiframe: false,
      showvideo: false,
      isadd: "",
      zh_CN,
      locale,
      yearShowOne: false,
      selectedRowKeys: [],
      tjshow: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 16 },
      loadings: false,
      sjData: {},
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps,
        // 其他 row-selection 的配置
      };
    },
  },
  watch: {
    dataList(newPrice) {
      this.data = newPrice;
    },
    isadd(newPrice) {
      this.isadd = newPrice;
    },
  },
  created() {},
  mounted() {},
  methods: {
    goAudit(record) {
      console.log("🚀 ~ goAudit ~ record:", record);
      const routerPathMap = {
        1: "/personalCenter/szStudio/auditPage",
        2: "/personalCenter/educationalBrand/auditPage",
        3: "/personalCenter/szMicroClass/auditPage",
      };
      this.$router.push({
        path: routerPathMap[record.applyType],
        query: {
          id: record.id,
          applyType: record.applyType,
          realname: record.realname,
          name: record.name,
        },
      });
    },
    tjsl(type) {
      // console.log(type);
      this.tjshow = true;
    },
    handleMenuClick(e) {
      console.log("click", e);
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.auditState == "1" || record.auditState == "2", // Column configuration not to be checked
        },
      };
    },
    batchsubmis() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        if (this.$route.name === "szStudio") {
          this.$message.warning("请选择要批量提交的工作室");
        } else if (this.$route.name === "educationalBrand") {
          this.$message.warning("请选择要批量提交的育人品牌");
        } else {
          this.$message.warning("请选择要批量提交的思政微课");
        }
      } else {
        let params = {
          applyType: applyType,
          applyIds: this.selectedRowKeys,
        };
        postAction("/lx/lxApply/submitBatch", params).then((res) => {
          if (res.code === 200) {
            this.$message.success("批量提交成功");
            this.goQuery();
            this.selectedRowKeys = [];
            this.$forceUpdate();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleOks() {
      this.importshow = false;
      this.list = [];
      this.goQuery();
    },
    tjOks() {
      this.tjshow = false;
      this.goQuery();
    },
    handleCancel() {
      this.importshow = false;
      this.list = [];
    },
    tjCancel() {
      this.tjshow = false;
    },
    downmb() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.form.chatType == "1") {
        lxApplyexportTemplate({ applyType: applyType }).then((res) => {
          let url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          let fileName = "";
          if (this.$route.name === "szStudio") {
            fileName = "思政工作室基本信息";
          } else if (this.$route.name === "educationalBrand") {
            fileName = "特色文化育人品牌基本信息";
          } else {
            fileName = "思政微课基本信息";
          }
          link.setAttribute("download", `${fileName}导入模板` + ".xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url);
        });
      } else {
        lxApplyexportQlTemplate({ applyType: applyType }).then((res) => {
          let url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          let fileName = "";
          if (this.$route.name === "szStudio") {
            fileName = "思政工作室全量信息";
          } else if (this.$route.name === "educationalBrand") {
            fileName = "特色文化育人品牌全量信息";
          } else {
            fileName = "思政微课全量信息";
          }
          link.setAttribute("download", `${fileName}导入模板` + ".xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url);
        });
      }
    },
    beforeUpload(file) {
      const formData = new FormData();
      formData.append("file", file);
      let url = "";
      if (this.form.chatType == "1") {
        if (this.$route.name === "szStudio") {
          url = "/lxBase/szStudioImport?applyType=1";
        } else if (this.$route.name === "educationalBrand") {
          url = "/lxBase/tsBrandStudioImport?applyType=2";
        } else {
          url = "/lxBase/wkImport?applyType=3";
        }
      } else {
        if (this.$route.name === "szStudio") {
          url = "/lxBase/combinedImport?applyType=1";
        } else if (this.$route.name === "educationalBrand") {
          url = "/lxBase/combinedImport?applyType=2";
        } else {
          url = "/lxBase/combinedImport?applyType=3";
        }
      }
      this.loadings = true;
      postAction(url, formData).then((res) => {
        if (res.code === 200) {
          console.log("111111");
          this.$message.success("导入成功");
          let that = this;
          setTimeout(function () {
            that.goQuery();
            that.loadings = false;
            that.importshow = false;
            that.list = [];
          }, 2000);
        } else {
          this.$message.warning(res.message);
          if (res.code == "201") {
            this.list = [];
            this.list.push({
              fileName: res.result.fileName,
              fileUrl: res.result.fileUrl,
            });
          }
          this.loadings = false;
        }
      });
      return false;
    },
    noopUpload() {},
    xteacherlist(record) {
      if (this.$route.name === "szStudio") {
        this.title = "工作室团队成员预览";
      } else if (this.$route.name === "educationalBrand") {
        this.title = "品牌团队成员预览";
      }
      this.num = 6;
      this.record = record;
      this.showtable = true;
    },
    teacherlist(record) {
      this.title = "团队成员预览";
      this.num = 0;
      this.record = record;
      this.showtable = true;
    },
    ppjd(record) {
      this.title = "品牌基地";
      this.num = 3;
      this.record = record;
      this.showtable = true;
    },
    pphd(record) {
      this.title = "品牌活动";
      this.num = 4;
      this.record = record;
      this.showtable = true;
    },
    zjlist(record) {
      this.title = "资金预览";
      this.num = 1;
      this.record = record;
      this.showtable = true;
    },
    arealist(record) {
      this.title = "思政实践基地预览";
      this.num = 5;
      this.record = record;
      this.showtable = true;
    },
    cglist(record) {
      this.title = "标志性成果预览";
      this.num = 2;
      this.record = record;
      this.showtable = true;
    },
    sbs(record) {
      if (
        record.declarationName != "" &&
        record.declarationName != null &&
        record.declarationPath != "" &&
        record.declarationPath != null
      ) {
        this.showiframe = true;
        this.previewUrl = record.declarationPath;
      } else {
        this.$message.warning("申报书暂未上传，请上传后预览");
      }
    },
    sp(record) {
      if (record.hasResource == "0") {
        this.$message.warning("思政视频暂未上传，请上传后预览");
      } else {
        // this.showvideo = true,

        getAction("/lxBase/lxApplyResource/getResourceByApplyId", {
          applyId: record.id,
        }).then((res) => {
          if (res.code === 200) {
            console.log(res, "111111");
            this.sjData = res.result;
            if (this.sjData.aliId) {
              this.showvideo = true;
            }
            console.log(this.sjData, ";222222222222222");
            // this.previewUrl = res.result.filePath;
          }
        });
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    // 得到年份选择器的值
    panelChangeOne(value) {
      console.log(value, "111111");
      this.queryCriteria.applyYear = value;
      this.yearShowOne = false;
    },
    handleChange(value) {
      this.queryCriteria.auditState = value;
    },
    goNewPage(flag) {
      console.log(flag);
      this.fullscreen = flag;
    },
    importsj() {
      this.list = [];
      if (this.$route.name === "szStudio") {
        this.titles = "思政工作室导入";
      } else if (this.$route.name === "educationalBrand") {
        this.titles = "特色文化育人品牌导入";
      } else {
        this.titles = "思政微课导入";
      }
      this.importshow = true;
    },
    jumpPages(type) {
      if (type === "") {
        let applyType = 0;
        if (this.$route.name === "szStudio") {
          applyType = 1;
        } else if (this.$route.name === "educationalBrand") {
          applyType = 2;
        } else {
          applyType = 3;
        }
        this.$router.push({
          name: `${this.$route.name}DataUpload`,
          query: {
            applyType,
            new: "new",
          },
        });
      }
    },
    jumpPage(type) {
      if (type === "") {
        //      let isAgree = window.localStorage.getItem("isAgree");
        //      if (isAgree === "true") {
        let applyType = 0;
        if (this.$route.name === "szStudio") {
          applyType = 1;
        } else if (this.$route.name === "educationalBrand") {
          applyType = 2;
        } else {
          applyType = 3;
        }
        this.$refs.identitypdf.init("add", { name: this.$route.name });
        //        // this.$emit("showAddPops", applyType);
        //        var data = {
        //          applyType: applyType,
        //        };
        //        schoolMaxNum(data).then((res) => {
        //          if (res.code == 200) {
        //            if (res.result == 0) {
        //              this.isadd = true;
        //            } else {
        //              if (this.dataList.length >= res.result) {
        //                this.isadd = false;
        //              } else {
        //                this.isadd = true;
        //              }
        //            }
        //            if (this.isadd == true) {
        // this.$router.push({
        //   name: `${this.$route.name}DataUpload`,
        //   query: {
        //     applyType,
        //     new: "new",
        //   },
        // });
        //            } else {
        //              this.$message.warning("本学校上报数据已达上限");
        //            }
        //          }
        //        });
        //      } else {
        //        this.$router.push({ name: `${this.$route.name}LetterCommitment` });
        //      }
      } else {
        this.$emit("showAddPop", type);
      }
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      let queryParam = {};
      queryParam.page = pagination.current;
      queryParam.size = pagination.pageSize;
      queryParam.realname = this.queryCriteria.schoolName;
      queryParam.name = this.queryCriteria.name;
      if (this.queryCriteria.applyYear && this.queryCriteria.applyYear != "") {
        queryParam.applyYear =
          new Date(this.queryCriteria.applyYear).getFullYear() + "";
      }
      console.log("this.queryCriteria", this.queryCriteria);
      console.log("queryParam.applyYear", queryParam.applyYear);
      queryParam.auditState = this.queryCriteria.auditState;
      this.$emit("getLxApplyApplylist", queryParam);
    },
    handleOk() {
      this.showDeleteModel = false;
      this.$emit("deleteApply", this.deteleId);
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$emit("editInfo", row);
    },
    preview(row, status) {
      // this.showPreviewPop = true;
      // this.preViewData = row;
      this.$emit("editInfo", row, status);
    },
    goQuery() {
      const pagination = {
        current: 1,
        pageSize: 10,
      };
      this.handleTableChange(pagination);
    },
  },
};
</script>

<style scoped lang="scss">
.header-time-box {
  width: 363px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  background: rgba(156, 3, 5, 0.1);
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2155b5;
  border-radius: 10px;
}

.add-btn {
  width: 86px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #2155b5;
  border-radius: 6px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.mb8 {
  margin-bottom: 8px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}

.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}

.table-box {
  text-align: center;
}

.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);

  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }

  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }

  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}

.header-search-box {
  font-size: 14px;
  padding-left: 7px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #383838;
  margin-top: 10px;
  margin-bottom: 15px;

  .input-style {
    width: 180px;
    height: 30px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    padding: 8px 12px;
    margin: 0 20px 0 6px;
  }

  .search-btn {
    width: 90px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #2155b5;
    border-radius: 6px;
    margin-left: 8px;

    // margin-right: 8px;
    .img-box {
      width: 12px;
      height: 14px;
      margin-right: 8px;
    }
  }
}

.downmb {
  line-height: 40px;
  cursor: pointer;
  color: #0f5ef1cc;
  /*margin-bottom:20px;*/
}

.img-box-hint {
  width: 18px;
  height: 18px;
  margin-right: 9px;
  display: inline-block;
  margin: 0 auto;
}
</style>
